export default __webpack_public_path__ + "static/media/Teaser.dcd7ff88.mp4";